import { KeyboardEventHandler, PropsWithChildren, useCallback } from 'react';

import {
  Popper,
  Paper,
  ClickAwayListener,
  MenuList,
  Fade,
} from '@mui/material';

import { useDropDownContext } from './DropDownContext';

export const DropDownMenuDesktop = ({
  children,
  ...rest
}: PropsWithChildren) => {
  const dropDownMenuContext = useDropDownContext();

  const handleListKeyDown: KeyboardEventHandler = useCallback(
    (event) => {
      if (event.key === 'Tab') {
        event.preventDefault();
        dropDownMenuContext.close(true);
      } else if (event.key === 'Escape') {
        dropDownMenuContext.close(true);
      }
    },
    [dropDownMenuContext.close]
  );

  return (
    <Popper
      open={dropDownMenuContext.isOpen}
      anchorEl={dropDownMenuContext.triggerRef}
      placement="bottom"
      transition
      popperOptions={{
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 8],
            },
          },
        ],
      }}
    >
      {({ TransitionProps }) => (
        <Fade {...TransitionProps}>
          <Paper
            sx={{ m: '0 1rem', paddingBottom: 'var(--ion-safe-area-bottom)' }}
          >
            <ClickAwayListener
              onClickAway={() => {
                dropDownMenuContext.close(true);
              }}
              mouseEvent="onMouseUp"
            >
              <MenuList
                autoFocusItem={dropDownMenuContext.isOpen}
                onKeyDown={handleListKeyDown}
                {...rest}
              >
                {children}
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Fade>
      )}
    </Popper>
  );
};
